import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { AssetsJson } from "../../../DynamicFormsJson/MastersJSON/assets";
import { getAssets } from "../../../Slice/assets.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../../components/withRouter";
import { assetsColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiGet, apiPost } from "../../../utils/api_service";
import { noInternetMsg, statusmsg } from "../../../config/messageconstant";
class AssetsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {},
    };
  }

  onChangeStatus = (rowData) => {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      let status = "";
      if (rowData.isActive == 0) {
        status = 1;
      } else {
        status = 0;
      }
      showLoador({ loador: true });
      apiPost({
        url:
          endpoint.assets +
          "/update-is-active?id=" +
          rowData.id +
          "&status=" +
          status,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          showNotification({ msg: statusmsg });
          window.location.reload();
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { assetsList, getAssets } = this.props;
    const { dynamicMasterData } = this.state;
    return (
      <>
        <DynamicMainScreen
          dynamicMasterData={dynamicMasterData}
          formPath={AssetsJson.formPath}
          screenTitle={AssetsJson.screenTitle}
          showPdfDownload={false}
          showExcelDownload={false}
          showExtension={false}
          pdfFileName={false}
          excelFileName={AssetsJson.excelFileName}
          showAddButton={AssetsJson.showAddButton}
          tableColumnsToFilter={AssetsJson.tableColumnsToFilter}
          tableColumns={assetsColumns}
          tableData={assetsList?.assets}
          getTableData={getAssets}
          getTableDataById={true}
          apiBaseURL={AssetsJson.apiBaseURL}
          baseIdColumn={AssetsJson.baseIdColumn}
          showDeleteIcon={true}
          //   isActionColActive={true}
          isActiveURLFalse={true}
          isActiveURLFalseMethod={this.onChangeStatus}
          showViewButtonInTable={true}
          formPathView={AssetsJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  assetsList: state.assets,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getAssets,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AssetsList);
